import { sameId } from "./helpers";

/**
 * Reads attempt history for a topic from the student tests payload (in memory).
 * @param {Array<{ cursoId?: string|number, bloques?: Array<{
 *   nombreBloque?: string,
 *   temas?: Array<{ nombreTema?: string, historial?: Array, intentos?: number }>
 * }> }>|null|undefined} userHistory
 * @param {string|number|null|undefined} courseId
 * @param {string} bloqueNombre
 * @param {string} temaNombre
 * @returns {{ historial: Array, intentos: number }}
 */
export function extractTopicTestHistory(userHistory, courseId, bloqueNombre, temaNombre) {
  if (!Array.isArray(userHistory) || courseId == null || courseId === "") {
    return { historial: [], intentos: 0 };
  }

  const courseHistory = userHistory.find((entry) => sameId(entry.cursoId, courseId));
  if (!courseHistory || !Array.isArray(courseHistory.bloques)) {
    return { historial: [], intentos: 0 };
  }

  const bloqueObj = courseHistory.bloques.find(
    (bloque) => String(bloque.nombreBloque) === String(bloqueNombre),
  );
  if (!bloqueObj || !Array.isArray(bloqueObj.temas)) {
    return { historial: [], intentos: 0 };
  }

  const temaObj = bloqueObj.temas.find(
    (tema) => String(tema.nombreTema) === String(temaNombre),
  );
  if (!temaObj) {
    return { historial: [], intentos: 0 };
  }

  const historial = Array.isArray(temaObj.historial) ? temaObj.historial : [];
  const intentos = Number.isFinite(Number(temaObj.intentos)) ? Number(temaObj.intentos) : 0;
  return { historial, intentos };
}
